import { AppSubjectEnum } from '../modules/authz/enums/app-subject.enum';

/**
 * Converts a payment target value (e.g. from URL query params) to the
 * corresponding app subject. Supports rental_reservation and rental_agreement;
 * other values return undefined.
 */
export function toAppSubjectForPaymentTarget(
	target: string | undefined,
): AppSubjectEnum | undefined {
	if (target == null) return undefined;

	const value = String(target);

	switch (value) {
		case 'rental_reservation':
			return AppSubjectEnum.RENTAL_RESERVATION;
		case 'rental_agreement':
			return AppSubjectEnum.RENTAL_AGREEMENT;
		default:
			return undefined;
	}
}
